const outer_menu = document.querySelector('#shopify-section-ve-mobile-menu');
const window_height = window.innerHeight;

document.addEventListener('DOMContentLoaded', function () {
    outer_menu.style.height = window_height + 'px';

    addEventListener("resize", () => {
        let window_height_resize = window.innerHeight;
        outer_menu.style.maxHeight = window_height_resize + 'px';
    });
})